<template lang="pug">
  .finland
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/finland-min.png"
      )
      span {{ gettext('Финляндия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Финляндия является республикой и членом Европейского Союза (ЕС). Страна делится на коммуны со своим самоуправлением. Имеет очень тесные связи с Швецией, Данией и Норвегией. Финляндия знаменита своей длинной холодной зимой, обширными лесами и тысячами озер. Как и все скандинавские страны, Финляндия довольно небольшая и является домом для 5,5 млн человек. Кроме финского и шведского языка (государственных) фины достаточно хорошо владеют английским.') }}
        p {{ gettext('В плане экономики Финляндия находится в десятке лидеров в мире, особенный пик развития приходится на последние несколько лет. Наиболее развиты секторы сельского и лесного хозяйства, индустрии, металлургии, машиностроения. Финляндия является центром для многих высокотехнологичных предприятий и занимается исследованиями в области нанотехнологий. Финляндия инвестирует свой капитал в науку и образование, а также в защиту окружающей среды, что делает ее очень привлекательной страной для иммигрантов с детьми.') }}
        p {{ gettext('Наиболее популярным и доступным для граждан третьих стран направлением в работе на территории Финляндии является сельское хозяйство. Ежегодно на сезонные работы в этом секторе по сбору урожая на полях и в лесах привлекается до 8 тысяч иностранных граждан. Очень много русских стремятся иммигрировать в Финляндию, переезжая целыми семьями. Один из пяти видов на жительство выдается россиянину. При знании финского языка и владении квалифицированным образованием  найти работу на финском рынке труда становится более реально.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/finland-min.png'})
  },
  name: 'Finland',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Finland | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/finland/index.vue